<script setup>
import RouterItem from "@/components/GlobusHeader/HeaderProject/ProjectHeaderRouting/RouterItem.vue";
import RouterItemProxy from "@/components/GlobusHeader/HeaderProject/ProjectHeaderRouting/RouterItemProxy.vue";
import {useStore} from "@/store";
import {useRouter} from "vue-router";

const store = useStore();
const router = useRouter();
</script>

<template>
  <div
    v-if="store.activeModule.dataName === 'module_proxy'"
    class="routing"
  >
    <RouterItemProxy
      v-for="item in store.routing"
      :key="item.id"
      :item="item"
    />
  </div>
  <div
    v-else-if="store.activeModule.dataName !== 'module_sources' && !router.currentRoute.value.fullPath.includes('/lk/')"
    class="routing"
  >
    <RouterItem
      v-for="route in store.routing"
      :key="route.id"
      :item="route"
    />
  </div>
  <div
    v-else-if="router.currentRoute.value.fullPath.includes('/lk/')"
    class="routing routing--empty"
  />
</template>

<style scoped lang="scss">
.routing {
  display: flex;

  &--empty {
    margin-left: -12px;
  }
}
</style>
